function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomBathAndToiletFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 7.81c0-1.41-.37-2.37-.85-2.95-.47-.57-1.12-.86-1.88-.86-.76 0-1.45.42-1.88 1.19 1.33.44 2.15 1.59 2.46 2.81.1.38.15.76.15 1.13V10h-8v-.87c0-.38.06-.76.17-1.13.4-1.35 1.51-2.57 3.1-2.91C20.86 3.3 22.34 2 24.26 2c1.32 0 2.54.53 3.41 1.58.86 1.03 1.32 2.48 1.32 4.23V19h-2V7.81H27zM19.34 8c.37-.57 1.01-1 1.81-1 .63 0 1.03.25 1.33.61.09.12.18.25.25.39h-3.39zm.8 6v-3h1.71v3h-1.71zm3.15 0H25v-3h-1.71v3zm-4.58 0H17v-3h1.71v3zM29 23h1v-2H16v2h11c0 3.31-2.69 6-6 6h-9.06v-1.18c1.82-.65 3.19-2.27 3.19-4.36v-1.45H6.92v-7H2v9h.03c.12 1 .55 1.93 1.24 2.67v2.33H2v2h28v-2h-3.71a7.99 7.99 0 002.71-6V23zM4.92 22v-5H4v5h.92zm-.86 2c.12.57.42 1.09.88 1.5l.33.3v2.78h4.67v-2.37l.82-.15c1.21-.22 2.08-1.03 2.31-2.07H4.06V24zM15 21H8v-2h7v2z",
    fill: props.color
  }));
}

export default SvgIconRoomBathAndToiletFilled;